import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

// components
import DropDown from '../../../components/dropdown/DropDown'
import Error from '../../../pages/Error'

// styles
import colors from '../../../styles/colors'

// constants
import * as constants from '../../../globals/constants'

// images
import CheckImg from '../../../assets/image/check/ic-checked.svg'
import UnCheckImg from '../../../assets/image/check/ic-unchecked.svg'
import DownImg from '../../../assets/image/arrow/ic-down.svg'

const Terms = ({
  privacyItem,
  serviceItem,
  ageItem,
  activeTerms,
  termsAgree,
  isAgree,
  agreementTime,
  handleArrow,
  handleCheck,
  // handleDropdown,
  handleAgree,
}) => {
  const htmlDecode = (html) => {
    // console.log('서비스', html)
    console.log('serviceItem.constents ', serviceItem.constents)
    if (html) {
      return {
        __html: `<iframe src=/termsHtml/${html}
        } frameborder="0" scrolling="yes" width="100%" height="400px"" </iframe>`,
      }
    } else {
      navigate('/error', { state: { navLink: true } })
    }
  }
  const [ageYn, setAgeYn] = useState(JSON.stringify(ageItem.agreementYn))
  const navigate = useNavigate()
  const [serviceYn, setServiceYn] = useState(!!serviceItem.constants)

  useEffect(() => {
    setServiceYn(true)
  }, [serviceItem.constants])

  useEffect(() => {
    setAgeYn(ageItem?.agreementYn) // JSON.stringify() 사용하지 않음
  }, [ageItem.agreementYn])

  // useEffect(() => {
  //   setAgeYn(JSON.stringify(ageItem.agreementYn))
  // }, [ageItem.agreementYn])

  // useEffect(() => {
  //   console.log('ageYn: ' + ageYn)
  // }, [ageYn, setAgeYn])

  return (
    <Container>
      {/* <div onClick={() => navigate('/error', { state: { navLink: true } })}>
        에러페이지 테스트
      </div> */}
      <TotalAgree>
        <img
          src={
            isAgree ||
            (termsAgree.service && termsAgree.privacy && termsAgree.age)
              ? CheckImg
              : UnCheckImg
          }
          onClick={() => {
            if (!isAgree) {
              handleCheck(0)
            }
          }}
        />
        <span>약관 전체 동의</span>
      </TotalAgree>

      {serviceYn ? (
        <ContentsWrapper>
          <HeaderContents>
            <AgreeWrapper>
              <img
                src={isAgree || termsAgree.service ? CheckImg : UnCheckImg}
                onClick={() => {
                  if (!isAgree && !serviceItem.isAgree) {
                    handleCheck(1)
                  }
                }}
              />
              <span onClick={() => handleArrow(0)}>[필수] 서비스이용약관</span>
            </AgreeWrapper>
            <DetailBtn
              type="button"
              isActive={activeTerms.service}
              onClick={() => handleArrow(0)}
            >
              [자세히보기]
            </DetailBtn>
          </HeaderContents>

          {activeTerms.service && (
            <BodyDetail>
              <BodyContents
                dangerouslySetInnerHTML={htmlDecode(serviceItem?.contents)}
              />
            </BodyDetail>
          )}
        </ContentsWrapper>
      ) : (
        navigate('/error', { state: { navLink: true } })
      )}
      <DivideLine />
      {ageYn === 'N' && (
        <>
          <ContentsWrapper>
            <HeaderContents>
              <AgreeWrapper>
                <img
                  src={isAgree || termsAgree.age ? CheckImg : UnCheckImg}
                  onClick={() => {
                    if (!isAgree) {
                      handleCheck(2)
                    }
                  }}
                />
                <span onClick={() => handleArrow(1)}>
                  [필수]만 14세 이상 사용자
                </span>
              </AgreeWrapper>
              <DetailBtn
                type="button"
                isActive={activeTerms.age}
                onClick={() => handleArrow(1)}
              >
                [자세히보기]
              </DetailBtn>
            </HeaderContents>

            {activeTerms.age && (
              <BodyDetail>
                <p className="detailTxt">
                  해피오더 사장님웹 서비스는 만 14세 이상의 이용자에게 제공되는
                  서비스 입니다.
                </p>
                <p className="detailTxt">
                  만 14세 미만 아동은 해피오더 사장님웹 서비스를 이용하실 수
                  없습니다.
                </p>
              </BodyDetail>
            )}
          </ContentsWrapper>
          <DivideLine />
        </>
      )}

      {privacyItem?.contents && (
        <ContentsWrapper>
          <HeaderContents>
            <AgreeWrapper>
              <img
                src={isAgree || termsAgree.privacy ? CheckImg : UnCheckImg}
                onClick={() => {
                  if (!isAgree && !privacyItem.isAgree) {
                    handleCheck(3)
                  }
                }}
              />
              <span onClick={() => handleArrow(2)}>
                [필수] 개인정보 수집 및 이용동의
              </span>
            </AgreeWrapper>
            <DetailBtn
              type="button"
              isActive={activeTerms.privacy}
              onClick={() => handleArrow(2)}
            >
              [자세히보기]
            </DetailBtn>
          </HeaderContents>

          {activeTerms.privacy && (
            <BodyDetail>
              <div className="tableWrap">
                <div className="tableCell header">수집목적</div>
                <div className="tableCell header">처리항목</div>
                <div className="tableCell header">보유 및 이용기간</div>

                <div className="tableCell">서비스 제공</div>
                <div className="tableCell">
                  해피오더 사장님웹 서비스 이용자 성명, 휴대폰번호, ID, PW,
                  대표자명, 사업자등록번호
                </div>
                <div className="tableCell" rowSpan="3">
                  서비스 종료 또는 이용자의 동의 철회 시 까지
                </div>
                <div className="tableCell">고객센터 운영 </div>
                <div className="tableCell">
                  해피오더 사장님웹 서비스 이용자 성명, 문의자 성명, 전화상담
                  녹취 파일 내 개인정보, 대표자명, 사업자등록번호
                </div>
                <div className="tableCell">
                  서비스 이용 또는 사업/ 처리과정에서 생성/수집되는 정보
                </div>
                <div className="tableCell">
                  접속일시, 디바이스 종류, os 종류 및 버전
                </div>
              </div>
              <p className="detailTxt">
                개인정보 수집 및 이용에 동의하지 않을 권리가 있습니다. 다만,
                동의 거부 시 ‘해피오더 사장님웹’ 서비스를 이용하실 수 없습니다.
              </p>
            </BodyDetail>
          )}
        </ContentsWrapper>
      )}
      <DivideLine />

      <AgreeBtn
        isAgree={isAgree}
        onClick={() => {
          if (!isAgree) {
            handleAgree()
          }
        }}
      >
        {isAgree ? '이미 동의한 약관입니다.' : '동의'}
      </AgreeBtn>
    </Container>
  )
}

export default Terms

const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`

const DropWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 23px;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 19px;
  }
`

const AgreeDate = styled.div`
  margin-right: 13px;
  color: ${colors.D3};

  @media ${(props) => props.theme.mobile} {
    margin-right: 0px;
  }
`

const TermDropDown = styled(DropDown)`
  width: 232px;

  .dropdown {
    margin-bottom: 0px !important;

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 15px;
  }
`

const TotalAgree = styled.div`
  margin-top: 60px;
  margin-bottom: 22px;
  padding: 0 25px;
  display: flex;
  align-items: center;

  img {
    cursor: pointer;
  }

  span {
    margin-left: 11px;
    color: #17a61c;
    font-size: 20px;
    font-weight: 700;
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 40px;
    padding: 0;
  }
`

const AgreeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  img {
    cursor: pointer;
  }

  span {
    flex: 1;
    margin-left: 11px;
    font-size: 16px;
    color: ${colors.BK};
    cursor: pointer;
  }
`

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 25px;
  margin: 20px 0;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }
`

const HeaderContents = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BodyContents = styled.div`
  display: flex;
  padding: 10px 0 0;
`

const BodyDetail = styled.div`
  padding: 8px 10px 15px;
  margin: 10px 10px 5px;
  border: 1px solid #676767;
  .tableWrap {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    /* grid-auto-rows: 1fr 1fr 1fr; */
    margin: 10px 0 30px;
    text-align: center;
  }

  .tableCell {
    border: 1px solid #000;
    padding: 5px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #676767;
    line-height: 1.5;
  }

  .tableCell.header {
    height: 30px;
    background-color: #ccc;
  }

  .tableCell[rowSpan='3'] {
    grid-row: span 3;
    display: flex;
    align-items: center;
  }

  .detailTxt {
    font-size: 13px;
    color: #676767;
    line-height: 1.5;
  }
`

const ArrowHeader = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: transform 0.5s ease;
  transform: ${(props) => (props.isActive ? `rotate(180deg)` : `rotate(0deg)`)};
`

const DetailBtn = styled.button`
  font-size: 13px;
  font-weight: bold;
  color: #8a8a8a;
`

const DivideLine = styled.div`
  height: 1px;
  background-color: ${colors.D3};
`

const AgreeBtn = styled.div`
  width: 100%;
  height: 57px;
  margin-top: 40px;
  border-radius: 10px;
  background-color: ${(props) =>
    props.isAgree ? `${colors.G7}` : `${colors.mainG}`};
  color: ${colors.W1};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.isAgree ? 'unset' : 'pointer')};
`
